import { FascicoloVO } from "../vo/fascicoloVO";
import { TipologiaFascicoloVO } from "../vo/tipologia-fascicoloVO";
import { Injectable } from "@angular/core";
import { FascicoloService } from "../services/fascicolo.service";
import { FiltroRicercaFascicoloVO } from "../vo/filtro-ricerca-fascicoloVO";
import { PaginazioneVO } from "../vo/paginazioneVO";
import { OrdinamentoVO } from "../vo/ordinamentoVO";
import { ResultListVO } from "../vo/resultList.vo";
import { VisibilitaRequestVO } from "../vo/visibilita-requestVO";
import { UtenteDTO } from "../dto/utenteDTO";
import { UtenteVO } from "../vo/utenteVO";
import { TipoVisibilitaEnum } from "../enum/tipo-visibilita-enum";
import { SettoreVO } from "../vo/settoreVO";
import { ListaVisibilitaVO } from "../vo/lista-visibilita/lista-visibilitaVO";
import { CampoSpecificoFascicolazioneVO } from "../vo/campo-specifico-fascicolazioneVO";
import { TipoCampoSpecificoEnum } from "../enum/tipo-campo-specifico-enum";


@Injectable({
  providedIn: "root",
})
export class FascicoloHelper {
  constructor() {}

  public static isVisibilitaProprietario(
    item: VisibilitaRequestVO,
    utente: UtenteVO
  ): boolean {
    return (
      item &&
      (item.tipoVisibilita.toString() === "PROPRIETARIO" ||
        (utente && utente.id === item.utente.id))
    );
  }

  public static isVisibilitaModificabile(
    item: VisibilitaRequestVO,
    utente: UtenteVO
  ): boolean {
    return (
      item &&
      (item.tipoVisibilita.toString() !== "PROPRIETARIO" ||
        (utente && utente.id !== item.utente.id))
    );
  }

  public static isVisibilitaModificabileSettori(
    item: VisibilitaRequestVO,
    settore: SettoreVO
  ): boolean {
    return (
      item &&
      (item.tipoVisibilita.toString() !== "PROPRIETARIO" ||
        (settore && settore.codice !== item.settore.codice))
    );
  }

  public static isVisibilitaModificabileGruppi(
    item: VisibilitaRequestVO,
    gruppo: ListaVisibilitaVO
  ): boolean {
    return (
      item &&
      (item.tipoVisibilita.toString() !== "PROPRIETARIO" ||
        (gruppo && gruppo.id !== item.gruppoVisibilita.id))
    );
  }

  public static verificaPropagazFigli(
    itemList: VisibilitaRequestVO[]
  ): VisibilitaRequestVO[] {
    console.log("verificaPropagazFigli begin", itemList);
    itemList.forEach((element) => {
      switch (element.tipoVisibilita) {
        case TipoVisibilitaEnum.SOLA_LETTURA_SOTTOFASCICOLI:
          element.tipoVisibilita = TipoVisibilitaEnum.SOLA_LETTURA;
          element.trasmettiAiFigli = true;
          break;
        case TipoVisibilitaEnum.MODIFICA_SOTTOFASCICOLI:
          element.tipoVisibilita = TipoVisibilitaEnum.MODIFICA;
          element.trasmettiAiFigli = true;
          break;
      }
    });
    console.log("verificaPropagazFigli end", itemList);
    return itemList;
  }

  public static isVisibilitaInModifica(
    mappaUtenti: Map<string, boolean>,
    item: VisibilitaRequestVO
  ): boolean {
    if (mappaUtenti == null) {
      return false;
    } else {
      return mappaUtenti.get(item.utente.id);
    }
  }
  public static isVisibilitaInModificaSettori(
    mappaSettori: Map<string, boolean>,
    item: VisibilitaRequestVO
  ): boolean {
    if (mappaSettori == null) {
      return false;
    } else {
      return mappaSettori.get(item.settore.codice);
    }
  }
  public static isVisibilitaInModificaGruppi(
    mappaGruppi: Map<string, boolean>,
    item: VisibilitaRequestVO
  ): boolean {
    if (mappaGruppi == null) {
      return false;
    } else {
      return mappaGruppi.get(item.gruppoVisibilita.id);
    }
  }


  public static getTipoAnagraficaCampo(campo: CampoSpecificoFascicolazioneVO) {
    switch (campo.tipoCampo) {
      case TipoCampoSpecificoEnum.LIBERO:
        return null;
      case TipoCampoSpecificoEnum.ANAGRAFICA_ESTERNA:
        return campo.tipoAnagrafica;
      case TipoCampoSpecificoEnum.ANAGRAFICA_MANUALE:
        return campo.nomeAnagrafica;
      default:
        return null;
    }
  }
}
